/**
 * @generated SignedSource<<86eaea75b3d2fbbc87489299cd4e9f3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TaskProblemTypingInput = {
  problem: EditorInput;
  solution: EditorInput;
  task: string;
};
export type EditorInput = {
  text: string;
  textHtml?: string | null;
};
export type TaskProblemTypingDialog_taskProblemTypingMutation$variables = {
  input: TaskProblemTypingInput;
};
export type TaskProblemTypingDialog_taskProblemTypingMutation$data = {
  readonly taskProblemTyping: {
    readonly id: string;
    readonly problem: string | null;
    readonly solution: string | null;
  };
};
export type TaskProblemTypingDialog_taskProblemTypingMutation = {
  response: TaskProblemTypingDialog_taskProblemTypingMutation$data;
  variables: TaskProblemTypingDialog_taskProblemTypingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TaskProblem",
    "kind": "LinkedField",
    "name": "taskProblemTyping",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "solution",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "problem",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskProblemTypingDialog_taskProblemTypingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskProblemTypingDialog_taskProblemTypingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "91697fb2630411bcf10f01bbbd04f5e5",
    "id": null,
    "metadata": {},
    "name": "TaskProblemTypingDialog_taskProblemTypingMutation",
    "operationKind": "mutation",
    "text": "mutation TaskProblemTypingDialog_taskProblemTypingMutation(\n  $input: TaskProblemTypingInput!\n) {\n  taskProblemTyping(input: $input) {\n    id\n    solution\n    problem\n  }\n}\n"
  }
};
})();

(node as any).hash = "b50652ddf11aedd0db4018a49bea380c";

export default node;
